const common = require('./common');

/**
 ***************************** 网络请求 ******************************************
 */
/**
 * @param {数据页索引} nPageIndex
 * @param {回调} fn
 * @param {当前选择的产品分类ID} categoryIDs
 * @param {当前选择的产品标签ID} labelIDs
 * @param {当前选择的产地名称} citys
 */
function requestProductList(nPageIndex, fn, categoryIDs = [], labelIDs = [], citys = [], strProvince, categoryNames = [], labelNames = [], ) {
  $.ajax({
    type: 'POST',
    url: '/product/list',
    data: {
      'categoryIDs': JSON.stringify(categoryIDs),
      'labelIDs': JSON.stringify(labelIDs),
      'categoryNames': JSON.stringify(categoryNames),
      'labelNames': JSON.stringify(labelNames),
      'citys': JSON.stringify(citys),
      'province': strProvince,
      'pageIndex': nPageIndex
    },
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        if (fn) {
          fn(true, response.data);
        }
      } else {
        if (fn) {
          fn(false, response.data);
        }
      }
    }
  });
}

function requestProductListByKeyword(nPageIndex, fn, keyword) {
  $.ajax({
    type: 'POST',
    url: '/product/keywordList',
    data: {
      'keyword': keyword,
      'pageIndex': nPageIndex
    },
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        if (fn) {
          fn(true, response.data);
        }
      } else {
        if (fn) {
          fn(false, response.data);
        }
      }
    }
  });
}

/**
 * 根据产品标签ID 返回对于的图标名称
 */
function imageNameForProductLabel(productLabelID) {
    var strImageName;
    if (productLabelID == 9) {
        strImageName = 'lvse';
    }
    else if (productLabelID == 4) {
        strImageName = 'baoxian';
    }
    else if (productLabelID == 1) {
        strImageName = 'chandi';
    }
    else if (productLabelID == 2) {
        strImageName = 'hexinchandi';
    }
    else if (productLabelID == 3) {
        strImageName = 'jiance';
    }
    else if (productLabelID == 5) {
        strImageName = 'suyuan';
    }
    else if (productLabelID == 6) {
        strImageName = 'renzheng';
    }
    else if (productLabelID == 7) {
        strImageName = 'wugonghai';
    }
    else if (productLabelID == 8) {
        strImageName = 'youji';
    }
    else if (productLabelID == 10 || productLabelID == 'A' || productLabelID == 'a') {
        strImageName = 'dibiao';
    }
    else if (productLabelID == 11 || productLabelID == 'B' || productLabelID == 'b') {
        strImageName = 'fupen';
    }
    else {
        return '';
    }
    return strImageName + '.png';
}

// const request = require('./request');
const pagination = require('./pagination');

/**
 * 动态向产品内容区添加产品
 * @param   
 *      products: [ProductEntity]
 */
function appendProductToDOM(products) {
  const divProductContent = $('.content .product-content .content');
  divProductContent.html('');
  const htmlText = products2HtmlText(products);
  divProductContent.append(htmlText);
  divProductContent.append('<div class="pagination"></div>');
}
/**
 * 通过网络加载产品列表数据
 * @param   
 *      categoryID: 产品分类ID  [string]
 *      labelID:   [string]
 *      city:   [string]
 *      strProvince:   string
 */
function getProductList(nPageIndex, fn, categoryID, labelID = [], city = [], strProvince, categoryNames, labelNames = []) {
  const elementTotal = $('.product-content-warpper .product-content .title');

  var strMsg;
  requestProductList(nPageIndex, function(bResult, data) {
    strMsg = '为您找到' + data.nTotalCount + '条产品';
    elementTotal.html(strMsg);
    appendProductToDOM(data.datas);
    pagination.appendPageToDOM(data, $('.product-content-warpper .product-content div.pagination'), bindPageItemClickEvent);
    fn && fn();
  }, categoryID, labelID, city, strProvince, categoryNames, labelNames);
}

function getProductListByKeyword(nPageIndex, fn, keyword) {
  const elementTotal = $('.product-content-warpper .product-content .title');
  let strMsg;
  requestProductListByKeyword(nPageIndex, function(bResult, data) {
    strMsg = '为您找到' + (data.nTotalCount || 0) + '条产品';
    elementTotal.html(strMsg);
    if (bResult && data.datas) {
      appendProductToDOM(data.datas);
      pagination.appendPageToDOM(data, $('.product-content-warpper .product-content div.pagination'), null, onClickedKeywordFilter);
    } else {
      appendProductToDOM([]);
      pagination.appendPageToDOM({}, $('.product-content-warpper .product-content div.pagination'), null, onClickedKeywordFilter);
    }
    fn && fn();
  }, keyword);
}
/**
 * 筛选产品列表
 */
function onClickedFilter(nPageIndex = 1, fn) {
  const {categoryIDs, categoryNames} = window.productFilter.extractProductCategoryIDs();
  const {labelIDs, labelNames} = window.productFilter.extractProductLabelIDs();
  const strProvince = window.productFilter.extractProvinceName();
  const arrCitys = window.productFilter.extractCityNames();
  getProductList(nPageIndex, fn, categoryIDs, labelIDs, arrCitys, strProvince, categoryNames, labelNames);
}

function onClickedKeywordFilter(index = 1) {
  const keyword = $('.pc-product-filter-panel .product-keyword input').val();
  getProductListByKeyword(index, function() {
    window.productFilter.reset();
  }, keyword);
}

/**
 * 点赞
 */
function onClickedStar(city) {
  var strProductID = $('.content .product-detail-content').attr('id');
  $.ajax({
    type: 'POST',
    url: '/product/star',
    data: {
      'productID': strProductID
    },
    success: function(response) {
      if (response && (response.errno == 0) && response.data && response.data.result) {
        var eleDiv = $('.introduce .left .view span #star span');
        var star = eleDiv.html();
        eleDiv.html(++star);
      } else {
      }
    }
  });
}
/**
 * 踩
 */
function onClickedUnstar(city) {
    var strProductID = $('.content .product-detail-content').attr('id');
    $.ajax({
        type:'POST',
        url: '/product/unstar',
        data:{
            'productID':strProductID
        },
        success:function (response){
            if (response && (response.errno == 0) && response.data && response.data.result){
                var eleDiv = $('.introduce .left .view span #unstar span');
                var star = eleDiv.html();
                eleDiv.html(++star);
            }
            else {
            }
        }
    } );
}

// 分页器事件绑定
function bindPageItemClickEvent() {
  $('.product-content-warpper .product-content div.pagination ul li').each(function(index) {
    const id = $(this).attr('id');
    $(this).click(function() {
      pagination.onClickedPageItem('.product-content-warpper .product-content div.pagination', id, onClickedFilter);
    });
  })
}

/**
 * 点击 直达购买 按钮处理
 */
function onClickedPurchase() {
  // const btnElement = $('.product-detail-content .introduce .right .btn');
  // var url = btnElement.attr('data');
  // if (url) {
  //     if ((url.indexOf('https://') == -1) && (url.indexOf('http://') == -1)) {
  //         url = 'https://' + url;
  //     }
  //     window.open(url);
  // }
  // else {
  //     url = btnElement.attr('dataH5');
  //     url = 'http://system.center.jgwcjm.com/apiInterface/common/qrCode?content=' + url;
  //     window.open(url); 
  // }
}
function onClickedMobilePurchase() {
  const btnElement = $('.product-detail-mobile .buy');
  var url = btnElement.attr('dataH5');
  if (url) {
    if ((url.indexOf('https://') === -1) && (url.indexOf('http://') === -1)) {
      url = 'https://' + url;
    }
    window.open(url);
  }
}
/**
 * 显示证书查看图片弹窗
 */
function displayCertificationImages(index) {
    var arrCertifications = extractCertificationImages();
    if ($('.mobile-body').length > 0) {//手机端
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = [];
        var nPictureIndex = 0;
        for (var i = 0; i < arrCertifications.length; i++) {
            var urls = arrCertifications[i];
            if (index > i) {
                nPictureIndex += urls.length;
            }
            urls.forEach(url => {
                items.push({src:url, w:400, h:600});
            });
        }
        // define options (if needed)
        var options = {
            // optionName: 'option value'
            // for example:
            index: nPictureIndex // start at first slide
        };
        
        // Initializes and opens PhotoSwipe
        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    }
    else {
        $('.product-detail-alert').css('display', 'block');
        const imageViewerElement = $('.product-detail-alert .alert-dialog-bk img.content');
        imageViewerElement.attr('src', arrCertifications[index][0]);
        imageViewerElement.attr('dataX', index);
        imageViewerElement.attr('dataY', 0);
    }
}
/**
 * 提取证书图片
 * @ret: [[url]]
 */
function extractCertificationImages() {
    var arrCertifications = [];
    var domNameCertificationImage = '.product-detail-content .introduce .right .report div span';
    if ($(domNameCertificationImage).length == 0){
        domNameCertificationImage = '.product-detail-mobile .title-detail .product-detail-certification .product-certification-item';
    }
    if ($(domNameCertificationImage).length > 0){
        $(domNameCertificationImage).each(function (index){
            var name = $(this).text();
            var url = $(this).attr('data');
            var arrUrl = url.split(',http');
            for (var i = 1; i < arrUrl.length; i++) {
                arrUrl[i] = 'http' + arrUrl[i];
            }
            arrCertifications.push(arrUrl);
        });
    }
    return arrCertifications;
}
function displayNextCertificationImage(){
    var arrCertifications = extractCertificationImages();
    const imageViewerElement = $('.product-detail-alert .alert-dialog-bk img.content');
    var nIndex = imageViewerElement.attr('dataX');
    var nIndexY = imageViewerElement.attr('dataY');
    if (nIndexY < arrCertifications[nIndex].length - 1) {
        nIndexY++;
        imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
        imageViewerElement.attr('dataY', nIndexY);
    }
    else if (nIndex < arrCertifications.length - 1) {
        nIndex++;
        nIndexY = 0;
        imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
        imageViewerElement.attr('dataY', nIndexY);
        imageViewerElement.attr('dataX', nIndex);
    }

}
function displayPreCertificationImage() {
  var arrCertifications = extractCertificationImages();
  const imageViewerElement = $('.product-detail-alert .alert-dialog-bk img.content');
  var nIndex = imageViewerElement.attr('dataX');
  var nIndexY = imageViewerElement.attr('dataY');
  if (nIndexY > 0) {
    nIndexY--;
    imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
    imageViewerElement.attr('dataY', nIndexY);
  } else if (nIndex > 0) {
    nIndex--;
    nIndexY = arrCertifications[nIndex].length - 1;
    imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
    imageViewerElement.attr('dataY', nIndexY);
    imageViewerElement.attr('dataX', nIndex);
  }
}

// 点击导航
function productTagInit() {
  const ProductFilter = require('./product/productFilter').ProductFilter;
  window.productFilter = new ProductFilter(function(citys, categoryIDs, labelIDs, province) {
    onClickedFilter(1, function() {
      $('.pc-product-filter-panel .product-keyword .ui-searchbar #id_keyword').val('');
    });
  });
  // pc端产品列表 搜索框
  const keywordDOM = $('.pc-product-filter-panel .product-keyword .ui-searchbar #id_keyword');
  keywordDOM && (keywordDOM.keypress(function(e) {
    let keyCode = null;
    if (e.which) {
      keyCode = e.which;
    } else if (e.keyCode) {
      keyCode = e.keyCode;
    }
    if (keyCode === 13) {
      onClickedKeywordFilter();
      return false;
    }
    return true;
  }));
  $('.pc-product-filter-panel .product-keyword .ui-searchbar .icon').on('click', () => onClickedKeywordFilter());

  $('.product-detail-content .introduce .left div span #star').click(onClickedStar);
  $('.product-detail-content .introduce .left div span #unstar').click(onClickedUnstar);
  bindPageItemClickEvent();
}

function productDetailInit() {
  //
  $('.product-detail-content .introduce .right .btn').on('click', onClickedPurchase);

  if ($('.product-detail-content .introduce .right .report div').length > 0) {
    $('.product-detail-content .introduce .right .report div').each(function(index) {
      $(this).click(function() {
        displayCertificationImages(index);
      });
    });
  } else if ($('.product-detail-mobile .title-detail .product-detail-certification .product-certification-item').length > 0) {
    $('.product-detail-mobile .title-detail .product-detail-certification .product-certification-item').each(function(index) {
      $(this).click(function() {
        displayCertificationImages(index);
      });
    });
  }
  // 证书查看弹窗关闭按钮
  $('.product-detail-alert .alert-dialog-bk .close-btn').on('click', function() {
    $('.product-detail-alert').css('display', 'none');
  });
  // 证书查看翻页
  $('.product-detail-alert .alert-dialog-bk .swiper-button-prev').on('click', displayPreCertificationImage);
  // 证书查看翻页
  $('.product-detail-alert .alert-dialog-bk .swiper-button-next').on('click', displayNextCertificationImage);

  // 手机端 直达购买 点击事件
  $('.product-detail-mobile .buy').on('click', onClickedMobilePurchase);
}

const init = () => {
  productTagInit();
  productDetailInit();

  var strRoute = '/product';
  if (location.href.indexOf(strRoute) + strRoute.length === location.href.length) {
    // 当前为产品列表页
  }
};
module.exports = { init };

function products2HtmlText(products) {
  let htmlText = '<div class="product-list">';
  products && products.length > 0 && products.forEach(product => {
    htmlText += product2Cell(product);
  });
  htmlText += ('</div>');
  return htmlText;
}
// 将产品信息转化为DOM元素
function product2Cell(product) {
  let htmlText = '<div class="product-list-item">';
  // 图片
  htmlText += ('<a href="/product/detail/' + product.id + '"><div>');
  if (typeof (product.picUrl) === 'string' && product.picUrl.length > 0) {
    htmlText += ('<img src="' + (product.picUrl || '') + '" />');
  } else if (typeof (product.picUrl) === 'object' && product.picUrl.length > 0) {
    htmlText += ('<img src="' + (product.picUrl[0] || '') + '" />');
  } else {
    htmlText += ('<img src="/static/image/wutupian-px.png" />');
  }
  htmlText += ('</div></a>');
  // 名称
  htmlText += ('<div class="product-name">' + (product.name || '') + '</div>');
  // 价格
  htmlText += ('<div class="price"' + (product.price ? '' : ' style="visibility:hidden"') + '>');
  htmlText += ('<div class="price-label">价格：</div>');
  htmlText += ('<div class="price-icon">￥</div>');
  htmlText += ('<div class="price-text">' + (product.price || '') + '</div>');
  htmlText += '</div>';
  // 供应商
  htmlText += ('<div class="supplier"' + (product.supplierName ? '' : ' style="display:none"') + '>');
  htmlText += ('供应商：' + (product.supplierName || ''));
  htmlText += ('</div>');
  // 标签
  htmlText += ('<div class="product-label">');
  product && product.labels && (htmlText += productLabel2HtmlText(product.labels));
  htmlText += ('</div>');

  htmlText += ('</div>');
  return htmlText;
}

function productLabel2HtmlText(labels) {
  let htmlText = '';
  labels && labels.forEach(element => {
    let icon = '';
    if (element == 1) {
      icon = 'chandi';
    } else if (element == 2) {
      icon = 'hexinchandi';
    } else if (element == 3) {
      icon = 'jiance';
    } else if (element == 4) {
      icon = 'baoxian';
    } else if (element == 5) {
      icon = 'suyuan';
    } else if (element == 6) {
      icon = 'renzheng';
    } else if (element == 7) {
      icon = 'wugonghai';
    } else if (element == 8) {
      icon = 'youji';
    } else if (element == 9) {
      icon = 'lvse';
    } else if (element === 'A' || element === 'a' || element == 10) {
      icon = 'dibiao';
    } else if (element === 'B' || element === 'b' || element == 11) {
      icon = 'fupen';
    }
    if (icon && icon.length > 0) {
      htmlText += ('<img src="/static/image/productDetail/' + icon + '.png" />');
    } else {
      htmlText += ('<div class="product-label-item">' + element + '</div>');
    }
  });
  return htmlText;
}
